<template>
  <div>
    <el-dialog title="提示" :visible.sync="dialogVisible" :before-close="handleClose" append-to-body>
      <p class="tip">{{ text }}</p>
      <el-progress :percentage="schedule"></el-progress>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'HintDialog',
  data() {
    return {
      text: '加载中...',
      timmer: null,
      schedule: 100,
      dialogVisible: false
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
      window.clearInterval(this.timeer)
      this.timmer = null
      this.schedule = 95 // 初始化加载进度
      this.getData()
    },
    handleClose() {
      this.dialogVisible = false
      window.clearInterval(this.timeer)
    },
    getData() {
      const that = this
      this.timeer = window.setInterval(function() {
        if (parseInt(that.schedule) < 100) {
          that.schedule = Number(that.schedule) + 1
        } else {
          that.schedule = 100
          that.dialogVisible = false
          that.$emit('reLoad')
          window.clearInterval(that.timeer)
        }
      }, 1800)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 480px !important;
  height: initial !important;
  background: #1A1A1A !important;
  border-radius: 8px;
  .tip {
    color: #dfdfdf;
    font-size: 16px;
    text-align: center;
    padding: 10px 0 15px 0;
  }
  .el-dialog__title{
    color: #fff !important;
  }
  .el-dialog__body {
    padding: 0 40px;
    padding-bottom: 49px;
   
    border-radius: 0px 0px 8px 8px;
  }
  .el-dialog__header {
   
    padding: 40px 40px 0 40px !important;
    border-radius: 8px 8px 0 0;
  }
  .el-progress__text {
    margin-left: 15px;
    font-size: 18px;
    color: #fff;
  }
  .el-dialog__footer {
 
  }
  .el-progress-bar {
    padding-right: 40px;
  }
  .el-dialog__headerbtn {
    top: 40px;
    right: 40px;
  }
  .el-progress-bar__outer{
    height: 8px !important;
    background-color: rgba(216, 216, 216, 0.5);
    border-radius: 4px;
  }
}
</style>
